import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useLanguageContext } from "../../Context/LanguageContext";
import TabsActions from "../../Actions/TabsActions";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import tabsStore from "../../Stores/TabsStore";
import tabsConstants from "../../Constants/TabsConstants";
import OrderDetails from "../Navigationsbar/Nav-Details/orderComponent/orderDetails";
import InspectionList from "../Equipment-Details/InspectionList";
import CheckListLoginUser from "../WebInspection/CheckListLoginUser";
import Access_ControlConstants from "../../Constants/Access_ControlConstants";
import access_ControlStore from "../../Stores/Access_ControlStores";
import InspectionOverview from "./InspectionOverview";

export default function PublicInspections({ equipmentDetails }) {
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [inspectionSetting, setInspectionSetting] = useState(
    equipmentDetails.inspectionDisplaySetting,
  );
  const [isUserLogged, setIsUserLogged] = useState(
    sessionStorage.getItem("token") ? true : false,
  );

  const [isContinueWithoutLogin, setIsContinueWithoutLogin] = useState(false);

  useEffect(() => {
    function savetokenLocal() {
      var result = access_ControlStore.getLoginInfo();
      sessionStorage.setItem("token", result.token);
      sessionStorage.setItem("organization", result.organization);
      sessionStorage.setItem("username", result.username);
      sessionStorage.setItem("userId", result.id);
      setIsUserLogged(true);
    }
    function loadError() {
      var result = access_ControlStore.getLoginError();
      toast.error(result);
      setGlobalSpinner(false);
    }
    access_ControlStore.addChangeListener(
      Access_ControlConstants.LOGIN_SUCCESS,
      savetokenLocal,
    );
    access_ControlStore.addChangeListener(
      Access_ControlConstants.LOGIN_FAILURE,
      loadError,
    );
    return () => {
      access_ControlStore.removeChangeListener(
        Access_ControlConstants.LOGIN_SUCCESS,
        savetokenLocal,
      );
      access_ControlStore.removeChangeListener(
        Access_ControlConstants.LOGIN_FAILURE,
        loadError,
      );
    };
  }, []);

  const handleBack = () => {
    setIsContinueWithoutLogin(false);
  };

  return (
    <>
      <div className="container p-0">
        {isUserLogged || isContinueWithoutLogin ? (
          <div className="table-responsive publicInspectionTable">
            {/* <InspectionList
              anlageid={equipmentDetails.anlageID}
              handleTourGuid={() => {}}
              equipmentDetails={equipmentDetails}
              isUserLogged={isUserLogged}
              logoutClick={setIsUserLogged}
              handleBack={handleBack}
            /> */}
            <InspectionOverview
              anlageid={equipmentDetails.anlageID}
              equipmentDetails={equipmentDetails}
              isUserLogged={isUserLogged}
              logoutClick={setIsUserLogged}
              handleBack={handleBack}
            />
          </div>
        ) : (
          <>
            <div className="public-inspections-message-container">
              <p className="public-inspections-message-text">
                {localization.loginToSeeFullDetailsMsg}
              </p>
            </div>
            <CheckListLoginUser />
            <div className="public-inspections-separator">
              <div className="public-inspections-separator-line" />
              <span className="public-inspections-separator-or">
                {localization.or}
              </span>
              <div className="public-inspections-separator-line" />
            </div>
            <div className="public-inspections-button-container">
              <button
                className="btn btn-primary public-inspections-continue-btn"
                onClick={() => {
                  setIsContinueWithoutLogin(true);
                }}
              >
                {localization.continueWithoutLogin}
              </button>
              <div className="public-inspections-note">
                {localization.limitedInfoNote}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
